import axios from 'axios';
import router from '../Router/index';

export default {
  namespaced: true,

  state: {
    sidebar_status: false,
    menuPart: '',
    // Remembers whether study-center day/week links use V2 or legacy V1 paths
    // while the user navigates template/reports under /centers/:slug/*.
    studyCenterRouteMode: null
  },

  getters: {
    getSidebarStatus(state) {
      return state.sidebar_status;
    },
    getMenuPart(state) {
      return state.menuPart;
    },
    getStudyCenterRouteMode(state) {
      return state.studyCenterRouteMode;
    }
  },

  mutations: {
    SET_SIDEBAR_STATUS(state, value) {
      state.sidebar_status = value;
    },
    SET_MENU_PART(state, value) {
      state.menuPart = value;
    },
    SET_STUDY_CENTER_ROUTE_MODE(state, value) {
      state.studyCenterRouteMode = value;
    }
  },

  actions: {
    setSidebarStatus({ commit }, value) {
      commit('SET_SIDEBAR_STATUS', value);
    },
    setMenuPart({ commit }, value) {
      commit('SET_MENU_PART', value);
    },
    setStudyCenterRouteMode({ commit }, value) {
      commit('SET_STUDY_CENTER_ROUTE_MODE', value);
    }
  }
};
